module.exports = __webpack_public_path__ + "static/media/fa-solid-900.bc595bb4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-solid-900.woff
// module id = 303
// module chunks = 0